import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text, TextLink, useTooltip } from '@frontend/design-system';

export const ReadOnlyInstructionField = ({
  instructionName,
  iconName,
  instructionType,
  onLinkClick,
}: {
  instructionName: string;
  iconName: IconName;
  instructionType?: string;
  onLinkClick?: () => void;
}) => {
  const { Tooltip: IconTooltip, tooltipProps, triggerProps } = useTooltip();

  // If onLinkClick is provided, use TextLink to make the whole component clickable, else
  // just display with a Text component.
  const ComponentWrapper = !!onLinkClick ? TextLink : Text;

  return (
    <ComponentWrapper
      {...triggerProps}
      onClick={() => onLinkClick?.()}
      css={css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing(1)};
        height: 32px;
        max-width: 250px;
      `}
    >
      <IconTooltip {...tooltipProps}>{`${
        instructionType ? `${instructionType}: ` : ''
      }${instructionName}`}</IconTooltip>
      <Icon
        name={iconName}
        size={18}
        css={css`
          flex-shrink: 0;
        `}
      />
      <Text
        css={css`
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: inherit;
        `}
      >
        {instructionName}
      </Text>
    </ComponentWrapper>
  );
};
